import React from 'react';
import { useGlobalAssets } from '../context/GlobalAssetContext';

interface Props {
    onClose: () => void;
    activeClientId?: string;
}

const AssetManagerModal: React.FC<Props> = ({ onClose, activeClientId }) => {
    const { assets, getAssetsByClient } = useGlobalAssets();
    const locations = activeClientId ? getAssetsByClient(activeClientId) : assets;

    return <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/80 p-4 backdrop-blur-sm">
        <div role="dialog" aria-modal="true" aria-labelledby="global-asset-manager-title" className="flex max-h-[90vh] w-full max-w-4xl flex-col overflow-hidden rounded-xl border border-slate-700 bg-slate-800 shadow-2xl">
            <div className="flex items-center justify-between border-b border-slate-700 p-6">
                <div>
                    <h2 id="global-asset-manager-title" className="text-2xl font-bold tracking-tight text-white">Global Asset Manager</h2>
                    <p className="mt-1 text-sm text-slate-400">Headquarters and additional locations managed on the management site.</p>
                </div>
                <button type="button" onClick={onClose} aria-label="Close locations" className="p-2 text-slate-400 transition-colors hover:text-white">
                    <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
                </button>
            </div>
            <div className="flex-1 overflow-y-auto bg-slate-900 p-6">
                <h3 className="mb-6 text-lg font-semibold text-white">Organization Locations ({locations.length})</h3>
                {locations.length ? <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
                    {locations.map(location => <article key={location.id} className="glass-panel p-4">
                        <h4 className="font-medium text-white">{location.name}</h4>
                        {location.isPrimary && <p className="mt-1 text-xs font-semibold text-blue-400">Headquarters · Primary location</p>}
                        <p className="mt-2 text-xs text-slate-400">{location.location?.address || location.country}</p>
                    </article>)}
                </div> : <p className="rounded-lg border border-dashed border-slate-700 p-8 text-center text-sm text-slate-400">Add headquarters and additional locations on the management site.</p>}
            </div>
        </div>
    </div>;
};

export default AssetManagerModal;
